 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		21: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		21: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"2852872c","2":"styles","3":"cbed22b0cd4ceb433016bf8636131cdcdf3c4e8b","4":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","5":"0eda96881945f8568a8bcdc7d146a7e5a5e06280","6":"27196ff0669588018fe60a7b5e74d643d5f7aee9","7":"e5987a4adffe4f3c6c9593ea3b27551e7bac5827","8":"9b841f6ee4d9518bbd88f3f5ed981216f56f5db3","9":"2c796e83","10":"118f4e12bd9b3e33d05cf87771159fb6017858a3","11":"071ef3b6e2b974b55a9cebc1078c3f75e2b72294","12":"0eceb729","13":"9c1524af","14":"acf7f1b5e86bf134a77d8673df0ebcfbaa166980","15":"0c264786","16":"9461ae24493fcffa85be1383c2c72d8ab099866b","17":"framework","18":"0e028c5cd82cb65437f0fb0f01298637ee02b03d","19":"4d1130bf21809b0e1dc511a913865fc5550d1d9f","20":"a3b6f702","24":"a9a7754c","26":"cb1608f2","27":"component---src-templates-callcenter-index-js","28":"component---src-templates-callcenter-login-js","29":"component---src-templates-callcenter-password-js","30":"component---src-templates-callcenter-signup-js","31":"component---src-templates-index-js","32":"component---src-templates-invite-js","33":"component---src-templates-invoice-js","34":"component---src-templates-login-js","35":"component---src-templates-manage-index-js","36":"component---src-templates-password-js","37":"component---src-templates-reservation-index-js","38":"component---src-templates-staff-index-js","39":"component---src-templates-staff-reset-js","40":"component---src-templates-staff-setup-js","41":"eabe11fc"}[chunkId]||chunkId) + "-" + {"0":"cc6f7803837c12145bd6","1":"6a236c00ec7f8c305da6","2":"7d4153d260c0197f0043","3":"2b76d19e3861f3c5220d","4":"1c68b680d30bf64480ea","5":"5c7b40d32aaad5ec7b89","6":"be7e72ce9bd6215911db","7":"898690af32889ba5d20b","8":"78ef927cf6a96ee5ca76","9":"24f06448913ed96e7534","10":"29c0a9f8bdc8f154bbb7","11":"9f448dc18c04db2d7bce","12":"ee4b308416dedb131ca1","13":"40df5f1e70ba4ea1dd9a","14":"6104ec282bfb3bf89900","15":"fa87e1fecab148a03071","16":"a74a9a8cc25ce57e4a9f","17":"a1e70247beed67c7a942","18":"dd8856b189eb13c623bd","19":"ae019ea910be58d30044","20":"1d5aa17ac0641f5e46a6","22":"9c6aabb570d23d81b595","23":"0d42c719c8db30591a18","24":"9ff35dd5dfb7891789e3","26":"22e7b8738a48abdecf0a","27":"a59ec60ed1afb0fa0a62","28":"09386014d678e63c3d61","29":"5cc48ebd52ef77e4f582","30":"e926da7b71923e2f3fb1","31":"5438f014fecb35047b7c","32":"3dca826422534655fa8d","33":"863905dbb1100d766e91","34":"f59e7cc411f03469582c","35":"0834de8e154998d915ba","36":"275d86579b131641e34f","37":"8cb5316b985bc5a306bb","38":"c18eb1c6589375ef1a58","39":"4912c7f3b39f638f6138","40":"0abfb29819ba7c758b78","41":"a0049885a24c375423ff","43":"ae71538a61cf577aab38","44":"c93711b28017d868b9b9","45":"2f49d5b546f6c7a90e6e","46":"6cba8b333e1223c8770d","47":"e7b56f62364c27d808c6","48":"4fde74d6e93021fd07a7","49":"711f7323396e5430bf03","50":"9cbaac21fe0e8148df67","51":"bc23b959a46e20cd65e3","52":"5a66a6e87a98502c88e1","53":"c46962476da87f3d2b93","54":"6979fdfa7afa972b9f71","55":"1520dd86c9230826fc3a","56":"02aefafc9e7eda875297","57":"a659425fb7e59f5a751e","58":"4612575b9334e3bd552a","59":"1228c52f21724f4da027","60":"7ed621ffef95ee9f1c04","61":"3311c1bc41fe46b82fe2","62":"7ec518d71bf7731006a0","63":"80f7dd4dca8eb4016ea3","64":"1002c3d2c276362cfa1d","65":"f80f9c1c6c26d1d321ed","66":"f289d149d8e79866c828","67":"11bd67433d0831400e2e","68":"279a9ee955523c283ca3","69":"b3bb70dfb6dd590f82f1","70":"e84a107b14cfbc903451","71":"9d1fc0282caf8cd6af89","72":"f67d574b4e7575beb345","73":"17433c1f38cfaa693b8f","74":"a83fc12e2c9ed4aa1aa4","75":"cf6b65c8b2a7daa99dd3","76":"b0e80388f51d824ca0e2","77":"abf6f8be0f78824f1cd5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"2852872c","2":"styles","3":"cbed22b0cd4ceb433016bf8636131cdcdf3c4e8b","4":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","5":"0eda96881945f8568a8bcdc7d146a7e5a5e06280","6":"27196ff0669588018fe60a7b5e74d643d5f7aee9","7":"e5987a4adffe4f3c6c9593ea3b27551e7bac5827","8":"9b841f6ee4d9518bbd88f3f5ed981216f56f5db3","9":"2c796e83","10":"118f4e12bd9b3e33d05cf87771159fb6017858a3","11":"071ef3b6e2b974b55a9cebc1078c3f75e2b72294","12":"0eceb729","13":"9c1524af","14":"acf7f1b5e86bf134a77d8673df0ebcfbaa166980","15":"0c264786","16":"9461ae24493fcffa85be1383c2c72d8ab099866b","17":"framework","18":"0e028c5cd82cb65437f0fb0f01298637ee02b03d","19":"4d1130bf21809b0e1dc511a913865fc5550d1d9f","20":"a3b6f702","24":"a9a7754c","26":"cb1608f2","27":"component---src-templates-callcenter-index-js","28":"component---src-templates-callcenter-login-js","29":"component---src-templates-callcenter-password-js","30":"component---src-templates-callcenter-signup-js","31":"component---src-templates-index-js","32":"component---src-templates-invite-js","33":"component---src-templates-invoice-js","34":"component---src-templates-login-js","35":"component---src-templates-manage-index-js","36":"component---src-templates-password-js","37":"component---src-templates-reservation-index-js","38":"component---src-templates-staff-index-js","39":"component---src-templates-staff-reset-js","40":"component---src-templates-staff-setup-js","41":"eabe11fc"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"c5a864baa62a13bc422d","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
